/** All links on the page. */
const getLinks = document.querySelectorAll("a");

/** Handle links on the page. */
const initExternalLinks = () =>
  Array.from(getLinks).filter((link) => link.hostname !== window.location.hostname || link.pathname.match(/\.(\w{3,4})$/) !== null)
    .filter((link) => link.classList.contains("js-external-link-exclude") === false)
    .map((link) => {
			link.setAttribute("target", "_blank");
			link.setAttribute("rel", "noopener noreferrer");
		});

document.addEventListener("htmx:after-swap", initExternalLinks);

export default initExternalLinks();
